import { extractMediaUrl, getStrapiFields } from '@/api/helpers'
import type { SeoContent } from './types'

const str = (val: unknown): string => (val == null ? '' : String(val))

function pickText(...values: unknown[]): string {
  for (const value of values) {
    const text = str(value)
    if (text) return text
  }
  return ''
}

/** Normalize Strapi `seo` component from metadata or service-pages. */
export function parseCmsSeo(raw: unknown): SeoContent | null {
  if (!raw || typeof raw !== 'object') return null

  const fields = getStrapiFields(raw)
  const metaTitle = pickText(
    fields.metaTitle,
    fields.MetaTitle,
    fields.seoTitle,
    fields.SeoTitle,
    fields.title,
    fields.Title
  )
  const metaDescription = pickText(
    fields.metaDescription,
    fields.MetaDescription,
    fields.seoDescription,
    fields.SeoDescription,
    fields.description,
    fields.Description
  )
  const keywords = pickText(fields.keywords, fields.Keywords, fields.metaKeywords, fields.MetaKeywords)
  const metaRobots = pickText(fields.metaRobots, fields.MetaRobots, fields.robots, fields.Robots)
  const canonicalUrl = pickText(
    fields.canonicalURL,
    fields.canonicalUrl,
    fields.CanonicalURL,
    fields.CanonicalUrl
  )
  const ogImage = extractMediaUrl(
    fields.metaImage ?? fields.MetaImage ?? fields.ogImage ?? fields.OgImage ?? fields.image ?? fields.Image
  )

  if (!metaTitle && !metaDescription && !keywords && !metaRobots && !canonicalUrl && !ogImage) {
    return null
  }

  return {
    metaTitle,
    metaDescription,
    keywords,
    metaRobots,
    canonicalUrl,
    ogImage,
  }
}
